import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';

export function Button() {
  return (
    <Link to='/lenguaje'>
      <button className='btn btn-lenguaje'>Languaje</button>
    </Link>
  );
}
